var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16111 8H6.33615M13 8H13.175M19.6619 8H19.8369M1 12.0833V3.91667C1 2.44391 2.19391 1.25 3.66667 1.25H22.3333C23.8061 1.25 25 2.44391 25 3.91667V12.0833C25 13.5561 23.8061 14.75 22.3333 14.75H3.66667C2.19391 14.75 1 13.5561 1 12.0833Z",
    stroke: "#81BC3D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.86aef01eaec71018ab627fa9e1ee70e4.svg";
export { ForwardRef as ReactComponent };